import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=9063e42c&scoped=true&"
import script from "./wangeditor.vue?vue&type=script&lang=js&"
export * from "./wangeditor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./wangeditor.vue?vue&type=style&index=1&id=9063e42c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9063e42c",
  null
  
)

export default component.exports